module.exports = __webpack_public_path__ + "img/subjectLogo.859521e1.png";